import { createSlice, PayloadAction, createSelector } from '@reduxjs/toolkit'
import { Budget, BudgetOverview } from '@/ts/interfaces/budgets'
import { RootState } from '@/store/index'

interface BudgetsState {
  budgets: Budget[]
  overview: BudgetOverview | null
}

const initialState: BudgetsState = {
  budgets: [],
  overview: null
}

export const budgetsSlice = createSlice({
  name: 'budgets',
  initialState,
  reducers: {
    setBudgets: (state, action: PayloadAction<Budget[]>) => {
      state.budgets = action.payload
    },
    setOverview: (state, action: PayloadAction<BudgetOverview>) => {
      state.overview = action.payload
    },
    addBudget: (state, action: PayloadAction<Budget>) => {
      state.budgets.push(action.payload)
    },
    updateBudgetInStore: (state, action: PayloadAction<Budget>) => {
      const index = state.budgets.findIndex((b) => b.id === action.payload.id)
      if (index !== -1) {
        state.budgets[index] = action.payload
      }
    },
    deleteBudgetFromStore: (state, action: PayloadAction<number>) => {
      state.budgets = state.budgets.filter((b) => b.id !== action.payload)
    },
    clearBudgets: (state) => {
      state.budgets = []
      state.overview = null
    }
  }
})

export const { setBudgets, setOverview, addBudget, updateBudgetInStore, deleteBudgetFromStore, clearBudgets } = budgetsSlice.actions

export const selectBudgets = (state: RootState) => state.budgets.budgets
export const selectBudgetOverview = (state: RootState) => state.budgets.overview
export const selectActiveBudgets = createSelector([selectBudgets], (budgets) => budgets.filter((b) => !b.deleted_at))

export default budgetsSlice.reducer
